import React from 'react';
import { connect } from 'react-redux';

// Components
import { Breakpoint } from '@americanexpress/aqx-components';
import { AprBox } from 'page_modules/business-pdp/components/AprBox';

// Selectors
import {
  getIsPayOverTimeCard,
  shouldShowDynamicAppPDP
} from 'page_modules/business-pdp/redux';

const AprBoxBelowHowYouEarn = ({ isPayOverTimeCard, shouldShowDynamicApp }) => (
  <Breakpoint>
    {({ sm, md }) => {
      const isMobileOrTablet = sm || md;
      const shouldRender =
        isPayOverTimeCard && (isMobileOrTablet || shouldShowDynamicApp);
      return shouldRender ? <AprBox /> : null;
    }}
  </Breakpoint>
);

const mapStateToProps = state => ({
  isPayOverTimeCard: getIsPayOverTimeCard(state),
  shouldShowDynamicApp: shouldShowDynamicAppPDP(state)
});

export default connect(mapStateToProps)(AprBoxBelowHowYouEarn);
